import VendaTable from './VendaTable';

export default VendaTable;
